import Container from '../../atoms/container/modalButtons';
import Focus from '../../../../shared/types/enums/focus';
import List from '../../sections/list/list';
import ModalButton from '../../atoms/buttons/genericButton';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useEffect } from 'react';
import { popRoute } from '../../../../shared/store/thunks/route.thunk';

function SubscribeAddonModalButtons() {
  const dispatch = useAppDispatch();
  const { enabled } = useAppSelector(magicRemoteSelector);

  const buttons = [
    {
      title: TranslationManager.get('MODAL.SUBSCRIBE_ADDON.BUTTONS.OK'),
      releaseAction: () => {
        dispatch(popRoute());
      },
    },
  ];

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  return (
    <Container>
      <List focus={Focus.MODAL_BUTTONS}>
        {buttons.map((item, index) => {
          return (
            <ModalButton
              focused={!enabled}
              index={index}
              key={index}
              onClick={item.releaseAction}
              releaseAction={item.releaseAction}
            >
              {item.title}
            </ModalButton>
          );
        })}
      </List>
    </Container>
  );
}

export default SubscribeAddonModalButtons;
